import Vue from "vue";
import Room from "./components/room/Room.vue";
import Login from "./components/login/Login.vue";
import NotFound from "./components/error/NotFound.vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export default new VueRouter({
    mode: "history",
    routes: [
        {
            path: "/rooms/:room_id",
            name: "Room",
            component: Room,
        },
        {
            path: "/login",
            name: "Login",
            component: Login,
        },
        {
            path: "*",
            component: NotFound,
        },
    ],
});
